//デジタルカタログWINDOWオブジェクト
var DcWin;
//サイトフラグ（ＮＯＬ）
var nolSiteName = 'nol';
//サイトフラグ（てせら）
var teseraSiteName = 'tesera';
//サイトフラグ（スマイルランド）
var smileSiteName = 'smile';

//デジタルカタログ画面を表示（ＮＯＬ）
function DcNolWinOpen(book, page, zoom, catalogue){
	DcWinOpen(book, page, zoom, nolSiteName, catalogue);
}

//デジタルカタログ画面を表示（てせら）
function DcTeseraWinOpen(book, page, zoom, catalogue){
	DcWinOpen(book, page, zoom, teseraSiteName, catalogue);
}

//デジタルカタログ画面を表示（スマイルランド）
function DcSmileWinOpen(book, page, zoom, catalogue){
	DcWinOpen(book, page, zoom, smileSiteName, catalogue);
}


//デジタルカタログ画面を表示
function DcWinOpen(book, page, zoom, site, catalogue){

//CookieOFF対応ST
	value1="ok";
	value2="";
	//windowサイズ
	//var wid = 1014;
	//var hei = 645;
	var wid = 1015;//20050415 デジタルカタログ２VINHLQ EDIT
	var hei = 664;//20050415 デジタルカタログ２VINHLQ EDIT 
	//windowを出す場所
	var x = (screen.width - wid ) / 2;
	var y = (screen.height - hei ) / 2;

	//nullチェック
	if(book==null) book = "";
	if(page==null) page = "";
	if(zoom==null) zoom = "";
	if(catalogue == null) catalogue = "";//デジタルカタログ　3分の計　対応 VJS_TUE 05/11/24

	//使用不可バージョンエラー画面ＵＲＬ
	// var versionErrUrl = "/digitalcatalog/error_browser.htm";
    var versionErrUrl = "https://www.nissen.co.jp/digitalcatalog/error_browser.htm";    

	//デジタルカタログフレーム画面ＵＲＬ
	//デジタルカタログ　3分の計　対応 VJS_TUE 2005/11/24 修正　BEGIN
	//var dcUrl = "/src/dc/DcViewFrameJsp.jsp?book=" + book + "&page=" + page + "&zoom=" + zoom + "&site=" + site;
	// var dcUrl = "/src/dc/DcViewFrameJsp.jsp?book=" + book + "&page=" + page + "&zoom=" + zoom + "&site=" + site + "&catalogue=" + catalogue;
    var dcUrl = "https://www.nissen.co.jp/src/dc/DcViewFrameJsp.jsp?book=" + book + "&page=" + page + "&zoom=" + zoom + "&site=" + site + "&catalogue=" + catalogue;
    
	//デジタルカタログ　3分の計　対応 VJS_TUE 2005/11/24 修正　END
	//表示画面URL
	var strOpenURL = "";

	tmp="COOKIE_CHK="+escape(value1)+";";
	document.cookie=tmp;
	tmp = document.cookie+";";
	tmp1 = tmp.indexOf("COOKIE_CHK",0);

	if(tmp1 != -1){
		tmp = tmp.substring(tmp1,tmp.length);
		start = tmp.indexOf("=",0);
		end = tmp.indexOf(";",start);
		value2 = unescape(tmp.substring(start+1,end));
	}

	if(value2 == "ok"){
		//デジタルカタログフレーム画面ＵＲＬをセット
		strOpenURL = dcUrl;
		//対象バージョンチェック
		if(!dcVarsionCheck()){
			//使用不可バージョンエラー画面ＵＲＬをセット
			strOpenURL = versionErrUrl;
		}
	}else{
		strWLSession = document.forms[0].WebLogicSession.value;
		strSessionID = document.forms[0].SessionID.value;
		//デジタルカタログフレーム画面ＵＲＬをセット
		strOpenURL = dcUrl + "&WebLogicSession=" + strWLSession + "&SessionID=" + strSessionID;
		//対象バージョンチェック
		if(!dcVarsionCheck()){
			//使用不可バージョンエラー画面ＵＲＬをセット
			strOpenURL = versionErrUrl + "&WebLogicSession=" + strWLSession + "&SessionID=" + strSessionID;
		}
	}

	DcWin = top.window.open(strOpenURL,
		"DcWin",
		'width='+wid+',height='+hei+',top='+y+',left='+x+'toolbar=no,location=no,menubar=no,scrollbars=no,resizable=yes,screenX=0screenY=0,left=0,top=0');
	if(window_Chek(DcWin)){
		DcWin.focus();
	}
}

//デジタルカタログWINDOWが開いていれば閉じる
function closeWin(objWin) {
	if(window_Chek(objWin)){
		objWin.close();
		objWin = null;
	}
}

//別ウインドウ有無確認する。windowがあれば true なければ false 
function window_Chek(winVar) {
	var ua = navigator.userAgent;
	if( winVar ){
		if( ua.indexOf('MSIE 4')!=-1 && ua.indexOf('Win')!=-1 ){
			return !winVar.closed;
		}
		else{
			return typeof winVar.document  == 'object';
		}
	}
	else{
		return false;
	}
}

//親windowを画面遷移させる
function openerNextScreen(url){
	//親windowが閉じているかをチェック
	if(!window_Chek(top.window.opener)){
//	if(top.window.opener.closed){
	//なければ別windowを開く
		new_win = top.window.open(url, "CartInfo");
		new_win.focus();
	}else{
	//あれば親windowを画面遷移させる
		top.window.opener.top.location.href = url;
		top.window.opener.top.blur();
		top.window.opener.top.focus();
	}
}

//リンクwindowを開く
function linkOpenWin(page,wname){
	//windowを開く
	linkWin = window.open(page,wname);
	//windowの存在チェックをしてあればそのwindowにフォーカスをあてる
	if(window_Chek(linkWin)){
		linkWin.focus();
	}
}

// ぶらうざ情報の取得(e3/n2)
// でも外部ファイルなので(e4/n3)オンコーディングにすれば上記通り)
// -------------------------
// ブラウザの情報を取得し戻す。
// -------------------------
// 戻り値
// this.app : アプリケーション名	値："NETSCAPE","INTERNET EXPLORER"etc..
// this.ver : バージョン番号		値：整数1桁＋小数点2桁(0.00～9.99)
// this.os  : PC環境			値："Win2003""WinXP""Win2K" etc..
// -------------------------
// 注意
// (1) mozillaはNetscapeとして判別
// (2) operaはInternet Explorerとして判別
// (3) versionは小数点2桁まで判別 5.0 -> 5.00
function GetBrowserInfo()
{
	var ua = navigator.userAgent.toUpperCase();
	var an = navigator.appName.toUpperCase();
	var m = 0;
	if(an.indexOf("MICROSOFT INTERNET EXPLORER") >= 0)
	{
		if((m = ua.indexOf("MSIE")) < 0)
		{
			this.app = "";
			this.ver = "0.00";
		}
		else
		{
			temp_ver = ua.substring(m);
			if((n = temp_ver.indexOf(".")) < 0)
			{
				this.app = "";
				this.ver = "0.00";
			}
		}
	}
	else
	if(an.indexOf("NETSCAPE") >= 0)
	{
		if((m = ua.indexOf("NETSCAPE")) >= 0)
		{
			temp_ver = ua.substring(m);
		}
		else
		{
			m = 0;
			temp_ver = ua;
		}
		if((n = temp_ver.indexOf(".")) < 0)
		{
			this.app = "";
			this.ver = "0.00";
		}
	}
	else
	{
		this.app = "";
		this.ver = "0.00";
	}

	if(this.ver != "0.00")
	{
		this.app = an;
		temp_char = ua.substring(n+m+2,n+m+3);
		if((temp_char < "0") || ("9" < temp_char))
		{
			if(temp_char == ".")
			{
				this.ver = ua.substring(n+m-1,n+m+2) + ua.substring(n+m+3,n+m+4);
			}
			else
			{
				this.ver = ua.substring(n+m-1,n+m+2) + "0";
			}
		}
		else
		{
			this.ver = ua.substring(n+m-1,n+m+3);
		}
	}

	this.os = 'Other';
	var plt = (navigator.platform) ? navigator.platform : 'Other';
	if(plt.indexOf("Win") != -1){
		if(ua.indexOf("NT 5.2") != -1 || ua.indexOf("WS 2003") != -1){ this.os = "Win2003"; }
		else if(ua.indexOf("NT 5.1") != -1 || ua.indexOf("WS XP") != -1){ this.os = "WinXP"; }
		else if(ua.indexOf("NT 5.0") != -1 || ua.indexOf("WS 2000") != -1){ this.os = "Win2K"; }
		else if(ua.indexOf("WIN 9x 4.90") != -1 || ua.indexOf("WS ME") != -1){ this.os = "WinME"; }
		else if(ua.indexOf("WIN98") != -1 || ua.indexOf("WS 98") != -1){ this.os = "Win98"; }
		else if(ua.indexOf("NT 4.0") != -1 || ua.indexOf("WINNT4") != -1){ this.os = "WinNT4"; }
		else if(ua.indexOf("WIN95") != -1 || ua.indexOf("WS 95") != -1){ this.os = "Win95"; }
		else if(ua.indexOf("WS CE") != -1){ this.os = "WinCE"; }
		else if(ua.indexOf("WS NT") != -1 || ua.indexOf("WINNT") != -1){ this.os = "WinNT"; }
		else if(ua.indexOf("WS 3.1") != -1){ this.os = "Win3.1"; }
		else{ this.os = plt;}
	}else if(plt.indexOf("Mac") != -1){
		this.os = (ua.indexOf("MAC OS X") != -1 || ua.indexOf("IE 5.2") != -1) ? "MacOSX" : plt;
	}else{ os = plt;}

}


//バージョンをチェックする、対象ブラウザならtrueを返す。
function dcVarsionCheck()
{
/* デジカタ改修修正
	//バージョンチェック結果
	var ret = false;
	//ブラウザ情報を取得
	browser = new GetBrowserInfo();
	//対象チェック
	if(
		 (browser.app == "MICROSOFT INTERNET EXPLORER") && 
		 (browser.ver >= "5.5") &&
		 (browser.os != "WinME") && (browser.os != "WinNT4") && 
		 (browser.os != "Win95") && (browser.os != "WinCE") && 
		 (browser.os != "WINNT") && (browser.os != "Win3.1") && 
		 (browser.os != "MacOSX") && (browser.os != "Other")
		)
	{
		ret = true;
	}
	return ret;
デジカタ改修修正*/
	return true;

}
//選択したカタログを開く。_20050425_FSOFT_VINHLQ

function openDc(strBookNo, strPageNo){
	if (strPageNo == null) strPageNo = "";
	top.parent.catalog.document.location.href = "DcViewJsp.jsp?page=" + strPageNo + "&book=" + strBookNo;
}

//デジタルカタログ画面を表示。_20050505_FSOFT_VINHLQ
function DcOpen(book, page, zoom, site, directFlg, countFlg, pageCount, currentRecord){

//CookieOFF対応ST
	value1="ok";
	value2="";
	//windowサイズ
	var wid = 1015;
	var hei = 664;
	//windowを出す場所
	var x = (screen.width - wid ) / 2;
	var y = (screen.height - hei ) / 2;

	//nullチェック
	if(book==null) book = "";
	if(page==null) page = "";
	if(zoom==null) zoom = "";

	//使用不可バージョンエラー画面ＵＲＬ
	var versionErrUrl = "/digitalcatalog/error_browser.htm";
	//デジタルカタログフレーム画面ＵＲＬ
	// var dcUrl = "/src/dc/DcViewFrameJsp.jsp?book=" + book + "&page=" + page + "&zoom=" + zoom + "&site=" + site + "&directFlg=" + directFlg + "&countFlg=" + countFlg + "&pageCount=" + pageCount + "&currentRecord=" + currentRecord;
    var dcUrl = "https://www.nissen.co.jp/src/dc/DcViewFrameJsp.jsp?book=" + book + "&page=" + page + "&zoom=" + zoom + "&site=" + site + "&directFlg=" + directFlg + "&countFlg=" + countFlg + "&pageCount=" + pageCount + "&currentRecord=" + currentRecord;
    
	//表示画面URL
	var strOpenURL = "";

	tmp="COOKIE_CHK="+escape(value1)+";";
	document.cookie=tmp;
	tmp = document.cookie+";";
	tmp1 = tmp.indexOf("COOKIE_CHK",0);

	if(tmp1 != -1){
		tmp = tmp.substring(tmp1,tmp.length);
		start = tmp.indexOf("=",0);
		end = tmp.indexOf(";",start);
		value2 = unescape(tmp.substring(start+1,end));
	}

	if(value2 == "ok"){
		//デジタルカタログフレーム画面ＵＲＬをセット
		strOpenURL = dcUrl;
		//対象バージョンチェック
		if(!dcVarsionCheck()){
			//使用不可バージョンエラー画面ＵＲＬをセット
			strOpenURL = versionErrUrl;
		}
	}else{
		strWLSession = document.forms[0].WebLogicSession.value;
		strSessionID = document.forms[0].SessionID.value;
		//デジタルカタログフレーム画面ＵＲＬをセット
		strOpenURL = dcUrl + "&WebLogicSession=" + strWLSession + "&SessionID=" + strSessionID;
		//対象バージョンチェック
		if(!dcVarsionCheck()){
			//使用不可バージョンエラー画面ＵＲＬをセット
			strOpenURL = versionErrUrl + "&WebLogicSession=" + strWLSession + "&SessionID=" + strSessionID;
		}
	}
	
	DcWin = top.window.open(strOpenURL,
		"DcWin",
		'width='+wid+',height='+hei+',top='+y+',left='+x+'toolbar=no,location=no,menubar=no,scrollbars=no,resizable=yes,screenX=0screenY=0,left=0,top=0');
	if(window_Chek(DcWin)){
		DcWin.focus();
	}
}


//商品詳細デジタルカタログ画面を表示
function DcWinOpenDetail(url){

	//CookieOFF対応ST
	value1="ok";
	value2="";
	//windowサイズ
	var wid = 1015;
	var hei = 664;
	//windowを出す場所
	var x = (screen.width - wid ) / 2;
	var y = (screen.height - hei ) / 2;
	//使用不可バージョンエラー画面ＵＲＬ
	// var versionErrUrl = "/digitalcatalog/error_browser.htm";
    var versionErrUrl = "https://www.nissen.co.jp/digitalcatalog/error_browser.htm";
    
	//デジタルカタログフレーム画面ＵＲＬ
	var dcUrl = url;
	//表示画面URL
	var strOpenURL = "";

	tmp="COOKIE_CHK="+escape(value1)+";";
	document.cookie=tmp;
	tmp = document.cookie+";";
	tmp1 = tmp.indexOf("COOKIE_CHK",0);

	if(tmp1 != -1){
		tmp = tmp.substring(tmp1,tmp.length);
		start = tmp.indexOf("=",0);
		end = tmp.indexOf(";",start);
		value2 = unescape(tmp.substring(start+1,end));
	}

	if(value2 == "ok"){
		//デジタルカタログフレーム画面ＵＲＬをセット
		strOpenURL = dcUrl;
		//対象バージョンチェック
		if(!dcVarsionCheck()){
			//使用不可バージョンエラー画面ＵＲＬをセット
			strOpenURL = versionErrUrl;
		}
	}else{
		strWLSession = document.forms[0].WebLogicSession.value;
		strSessionID = document.forms[0].SessionID.value;
		//デジタルカタログフレーム画面ＵＲＬをセット
		strOpenURL = dcUrl + "&WebLogicSession=" + strWLSession + "&SessionID=" + strSessionID;
		//対象バージョンチェック
		if(!dcVarsionCheck()){
			//使用不可バージョンエラー画面ＵＲＬをセット
			strOpenURL = versionErrUrl + "&WebLogicSession=" + strWLSession + "&SessionID=" + strSessionID;
		}
	}

	DcWin = top.window.open(strOpenURL,
		"DcWin",
		'width='+wid+',height='+hei+',top='+y+',left='+x+'toolbar=no,location=no,menubar=no,scrollbars=no,resizable=yes,screenX=0screenY=0,left=0,top=0');
	if(window_Chek(DcWin)){
		DcWin.focus();
	}
}
